import React from "react";
import "../../assets/styles/Loader.css"
// import Logo from "../../assets/images/main-logo.png";

const Loader = () => {
  return (
    <div className="loader-container">
    <div className="loader">
    {/* <div className="loader-border"></div> */}
      {/* <img src={Logo} alt="Website Logo" className="loader-logo" /> */}
    </div>
  </div>
  );
};
export default Loader;

